import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const SchedulingIntegration = () => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [selectedTeam, setSelectedTeam] = useState(null);

  // Mock calendar data
  const availableDates = [
    { date: '2025-08-14', day: 'Thu', slots: 6 },
    { date: '2025-08-15', day: 'Fri', slots: 4 },
    { date: '2025-08-18', day: 'Mon', slots: 8 },
    { date: '2025-08-19', day: 'Tue', slots: 5 },
    { date: '2025-08-20', day: 'Wed', slots: 7 },
    { date: '2025-08-21', day: 'Thu', slots: 3 },
    { date: '2025-08-22', day: 'Fri', slots: 6 }
  ];

  const timeSlots = [
    { time: '09:00 AM', available: true },
    { time: '10:30 AM', available: true },
    { time: '12:00 PM', available: false },
    { time: '01:30 PM', available: true },
    { time: '03:00 PM', available: true },
    { time: '04:30 PM', available: false }
  ];

  const localTeams = [
    {
      id: 'sf-team',
      name: 'San Francisco Bay Area Team',
      lead: 'Michael Rodriguez',
      specialties: ['Enterprise Fiber', 'Data Centers'],
      rating: 4.9,
      completedProjects: 127,
      responseTime: '2 hours',
      coverage: 'San Francisco, Oakland, San Jose'
    },
    {
      id: 'la-team',
      name: 'Los Angeles Metro Team',
      lead: 'Sarah Chen',
      specialties: ['Healthcare Networks', 'Financial Services'],
      rating: 4.8,
      completedProjects: 98,
      responseTime: '1.5 hours',
      coverage: 'Los Angeles, Long Beach, Anaheim'
    },
    {
      id: 'sd-team',
      name: 'San Diego Team',
      lead: 'David Thompson',
      specialties: ['Manufacturing', 'Biotech'],
      rating: 4.9,
      completedProjects: 76,
      responseTime: '2.5 hours',
      coverage: 'San Diego, Carlsbad, Chula Vista'
    }
  ];

  const handleDateSelect = (date) => {
    setSelectedDate(date);
    setSelectedTime(null); // Reset time when date changes
  };

  const handleTimeSelect = (time) => {
    setSelectedTime(time);
  };

  const handleTeamSelect = (teamId) => {
    setSelectedTeam(teamId);
  };

  const handleScheduleConsultation = async () => {
  if (selectedDate && selectedTime && selectedTeam) {
    console.log("Scheduling consultation:", {
      date: selectedDate,
      time: selectedTime,
      team: selectedTeam,
    });

    const data = new FormData();
    data.append("formType", "Schedule Consultation");
    data.append("date", selectedDate);
    data.append("time", selectedTime);
    data.append("team", selectedTeam);

    // Optional extra fields (you can collect from user form if available)
    data.append("name", "John Doe");
    data.append("email", "john@example.com");
    data.append("phone", "123-456-7890");
    data.append("company", "Sample Company");
    data.append("message", "Looking forward to the consultation!");

    try {
      const response = await fetch("/send-mail.php", {
        method: "POST",
        body: data,
      });

      const result = await response.text();
      if (result === "success") {
        alert("✅ Consultation request sent successfully!");
      } else {
        alert("⚠️ Failed to send consultation request. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("❌ Something went wrong while sending consultation request.");
    }
  } else {
    alert("⚠️ Please select date, time, and team first.");
  }
};


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric' 
    });
  };

  return (
    <div className="bg-white rounded-lg shadow-brand-moderate p-6 md:p-8">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-text-primary mb-3">Schedule Your Consultation</h2>
        <p className="text-text-secondary max-w-2xl mx-auto">
          Book a consultation with our local team. Choose a convenient time and we'll come to your location 
          for a comprehensive assessment.
        </p>
      </div>
      <div className="space-y-8">
        {/* Date Selection */}
        <div>
          <h3 className="text-lg font-semibold text-text-primary mb-4 flex items-center">
            <Icon name="Calendar" size={20} className="mr-2 text-primary" />
            Select Date
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-3">
            {availableDates?.map((dateOption) => (
              <button
                key={dateOption?.date}
                onClick={() => handleDateSelect(dateOption?.date)}
                className={`p-3 rounded-lg border text-center transition-all duration-200 ${
                  selectedDate === dateOption?.date
                    ? 'border-primary bg-primary text-white shadow-brand-subtle'
                    : 'border-border hover:border-primary hover:bg-primary/5'
                }`}
              >
                <div className="text-sm font-medium">{dateOption?.day}</div>
                <div className="text-lg font-bold">{formatDate(dateOption?.date)}</div>
                <div className="text-xs opacity-75">{dateOption?.slots} slots</div>
              </button>
            ))}
          </div>
        </div>

        {/* Time Selection */}
        {selectedDate && (
          <div>
            <h3 className="text-lg font-semibold text-text-primary mb-4 flex items-center">
              <Icon name="Clock" size={20} className="mr-2 text-primary" />
              Select Time
            </h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
              {timeSlots?.map((slot) => (
                <button
                  key={slot?.time}
                  onClick={() => slot?.available && handleTimeSelect(slot?.time)}
                  disabled={!slot?.available}
                  className={`p-3 rounded-lg border text-center transition-all duration-200 ${
                    !slot?.available
                      ? 'border-border bg-muted text-text-secondary cursor-not-allowed opacity-50'
                      : selectedTime === slot?.time
                      ? 'border-primary bg-primary text-white shadow-brand-subtle'
                      : 'border-border hover:border-primary hover:bg-primary/5'
                  }`}
                >
                  <div className="font-medium">{slot?.time}</div>
                  {!slot?.available && (
                    <div className="text-xs mt-1">Unavailable</div>
                  )}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Team Selection */}
        {selectedDate && selectedTime && (
          <div>
            <h3 className="text-lg font-semibold text-text-primary mb-4 flex items-center">
              <Icon name="Users" size={20} className="mr-2 text-primary" />
              Select Local Team
            </h3>
            <div className="space-y-4">
              {localTeams?.map((team) => (
                <div
                  key={team?.id}
                  onClick={() => handleTeamSelect(team?.id)}
                  className={`p-4 rounded-lg border cursor-pointer transition-all duration-200 ${
                    selectedTeam === team?.id
                      ? 'border-primary bg-primary/5 shadow-brand-subtle'
                      : 'border-border hover:border-primary hover:shadow-brand-subtle'
                  }`}
                >
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <div className="flex items-center space-x-3 mb-2">
                        <h4 className="font-semibold text-text-primary">{team?.name}</h4>
                        <div className="flex items-center space-x-1">
                          <Icon name="Star" size={16} className="text-warning fill-current" />
                          <span className="text-sm font-medium text-text-secondary">{team?.rating}</span>
                        </div>
                      </div>
                      
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm text-text-secondary">
                        <div>
                          <p className="font-medium text-text-primary mb-1">Team Lead</p>
                          <p>{team?.lead}</p>
                        </div>
                        <div>
                          <p className="font-medium text-text-primary mb-1">Specialties</p>
                          <p>{team?.specialties?.join(', ')}</p>
                        </div>
                        <div>
                          <p className="font-medium text-text-primary mb-1">Coverage Area</p>
                          <p>{team?.coverage}</p>
                        </div>
                      </div>
                      
                      <div className="flex items-center space-x-6 mt-3 text-sm">
                        <div className="flex items-center space-x-1">
                          <Icon name="CheckCircle" size={16} className="text-accent" />
                          <span>{team?.completedProjects} projects completed</span>
                        </div>
                        <div className="flex items-center space-x-1">
                          <Icon name="Clock" size={16} className="text-primary" />
                          <span>Avg response: {team?.responseTime}</span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="flex-shrink-0 ml-4">
                      {selectedTeam === team?.id && (
                        <Icon name="CheckCircle" size={24} className="text-primary" />
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Confirmation */}
        {selectedDate && selectedTime && selectedTeam && (
          <div className="bg-accent/10 border border-accent/20 rounded-lg p-6">
            <h4 className="font-semibold text-text-primary mb-4 flex items-center">
              <Icon name="CheckCircle" size={20} className="mr-2 text-accent" />
              Consultation Summary
            </h4>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6 text-sm">
              <div>
                <p className="font-medium text-text-primary mb-1">Date & Time</p>
                <p className="text-text-secondary">
                  {formatDate(selectedDate)} at {selectedTime}
                </p>
              </div>
              <div>
                <p className="font-medium text-text-primary mb-1">Team</p>
                <p className="text-text-secondary">
                  {localTeams?.find(t => t?.id === selectedTeam)?.name}
                </p>
              </div>
              <div>
                <p className="font-medium text-text-primary mb-1">Duration</p>
                <p className="text-text-secondary">2-4 hours (on-site assessment)</p>
              </div>
            </div>
            
            <Button
              variant="default"
              size="lg"
              onClick={handleScheduleConsultation}
              iconName="Calendar"
              iconPosition="left"
              className="cta-primary w-full sm:w-auto"
            >
              Confirm Consultation Booking
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SchedulingIntegration;